<template>
  <div class="box" style="background-color: hsl(229, 53%, 96%); padding: 12px">
    <h1 class="title is-4">Opciones del empleador</h1>
        <h3 class="subtitle is-6">Seleccione el firmador a utilizar</h3>
<!--         <div class="box is-flex is-flex-direction-row is-align-items-center p-3" v-if="user && user.firmadores_habilitados.signar">
          <div class="is-flex-grow-1">
           <b-radio v-model="firmadorSelected"
              native-value="signar">
              <i class="fas fa-upload fa-fw"></i>&nbsp;Firmador Desktop&nbsp;<b>Signar® v1</b>
          </b-radio>
          </div>
        </div>
 -->        <div class="box is-flex is-flex-direction-row is-align-items-center p-2" v-if="user && user.firmadores_habilitados.pfdrar">
          <div class="is-flex-grow-1">
          <b-radio disabled v-model="firmadorSelected" native-value="pfdrar">
              <p class="has-text-danger is-size-7">No disponible</p>
              <b>Plataforma de Firma Digital Remota</b> - Secretaria de Modernización - Argentina
          </b-radio>
          </div>
          <img v-if="1===2" src="/statics/pfdrar-logo.png" class="image firmador-select" alt>
        </div>

        <div class="box is-flex is-flex-direction-row is-align-items-center p-3" v-if="user && user.firmadores_habilitados.signar">
            <div class="is-flex-grow-1">
              <b-radio v-model="firmadorSelected" native-value="signar_v3">
              <i class="fas fa-upload fa-fw"></i><b>&nbsp;Firmador Integrable v3</b>
            </b-radio>
            <!-- Seleccionar el tipo de recibo a subir en la plataforma Web, en vez de hacerlo desde el firmador -->
            <div class="control">
              <label for="" class="subtitle is-6" :class="{ 'has-text-grey-light': firmadorSelected != 'signar_v3' }">
                Seleccione el tipo de recibo a subir</label>
              <div class="select is-fullwidth">
                <select name="" v-model="tipoRecibosSelected" :disabled="firmadorSelected != 'signar_v3'"
                :style="{ opacity: (firmadorSelected != 'signar_v3') ? 0.5 : 1 }">
                <option :value="recibo.id" v-for="(recibo, i) in tiposRecibos" :key="i">{{recibo.nombre}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons is-centered">
<!--          <div class="buttons my-2">
             <a @click="$emit('launch-firmador','current', '')" class="button is-primary is-fullwidth">
            <i class="fas fa-upload fa-fw"></i><b>&nbsp;Subir recibos &nbsp;</b></a>
 -->
            <button @click="goFirmar(firmadorSelected)" class="button is-primary is-fullwidth"
              :disabled="!firmadorSelected || (firmadorSelected === 'signar_v3' && !(tipoRecibosSelected))">
              <i class="fas fa-upload fa-fw"></i>&nbsp;Subir Recibos</button>
        </div>
      <b-collapse :open="false" position="is-top" aria-id="contentIdForA11y1">
      <template #trigger="props">
        <a aria-controls="contentIdForA11y1" class="is-size-7 has-text-dark">
            <i class="fas " :class="!props.open ? 'fa-caret-down' : 'fa-caret-up'"></i>
            {{ !props.open ? 'Más opciones' : 'Ocultar opciones' }}
        </a>
      </template>
      <div class="mt-3 is-size-7">
        <a @click="$emit('launch-firmador','jnlp')" class=""><i class="fas fa-upload fa-fw"></i>&nbsp;Subir recibos usando el firmador JNLP (legacy)</a>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tiposRecibos: [],
      tipoRecibosSelected: null,
      firmadorSelected: null
    }
  },
  created: function () {
    this.$eventHub.$on('showPila', this.open)
    this.$eventHub.$on('togglePila', this.toggle)
    this.firmadorSelected = this.seleccionarFirmador()
  },
  mounted () {
    this.getTiposRecibos()
  },
  computed: {
    user: function () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    seleccionarFirmador: function () {
      if (!this.$store.getters.getUser) return null
      if (this.$store.getters.getUser.firmadores_habilitados.signar) return 'signar_v3'
      if (this.$store.getters.getUser.firmadores_habilitados.pfdrar) return 'pfdrar'
      return null
    },
    goFirmar (firmadorSeleccionado) {
      switch (firmadorSeleccionado) {
        case 'signar':
          this.$emit('launch-firmador', 'current', '')
          break
        case 'signar_v3':
          this.$emit('launch-firmador', 'firmador30', this.tipoRecibosSelected)
          break
        case 'pfdrar':
          this.$emit('launch-firmador', 'current', '')
          break
        default:
          break
      }
    },
    getTiposRecibos () {
      this.$http.get('/tipo-recibo')
        .then(res => {
          this.tiposRecibos = res.data
          this.loadingTiposRecibos = false
        }).catch(err => {
          console.error(err)
          this.$buefy.snackbar.open({
            message: 'Error en la comunicación. Por favor recargue la página',
            type: 'is-warning',
            actionText: 'Recargar',
            indefinite: true,
            onAction: () => {
              location.reload()
            }
          })
        })
    }
  }

}
</script>
<style lang="scss" scoped>
.firmador-select{
  width: 75px;
  height: auto;
}
</style>
